import { ProcessoMovimentacao } from './processo-movimentacao';

export class ProcessoAnexo {

  public Id: number;
  public Data: string;
  public ArquivoNome: string;
  public Extensao: string;
  public Descricao: string;
  public UsuarioNome: string;
  public Usuario: string;
  public TipoMovimentacaoId: number;
  public TipoDocumentoId: number;
  public Documento: string;
  public DocumentoDescricao: string;
  public SomenteDesdeProcesso: boolean;
  public Subcategoria: string;
  public SubcategoriaId: number;
  public Ativo: boolean;
  public ProcessoMovimentacao: ProcessoMovimentacao;
  public UsuarioPodeExcluir: boolean;
  public Selecionado: boolean;
  public MovimentacaoId: number;
  public ProcessoId: number;
  public Sigiloso: boolean;
  public PermissaoAcessarSigilo: boolean;


  constructor() {
    this.ProcessoMovimentacao = new ProcessoMovimentacao();
  }

}
